<template>
  <div>
    <vxe-grid
      ref="orderGoodsTable"
      resizable
      auto-resize
      highlight-hover-row
      :tree-config="treeConfig"
      :toolbar-config="toolbarConfig"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      size="mini"
      :cell-class-name="cellClassName"
      :row-style="rowStyle"
      row-id="pdCostsOrderGoodsCode"
      class="pd-order-goods"
      show-footer
      :footer-method="() => footerData"
      :height="height"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl|| '/image/static/img/nopic.jpg',
          "
          style="width:60px; height:60px"
          @click="imgClick(row)"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width:60px; height:60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:showGoods="{ row }">
        <div v-if="!row.pdCostsOrderGoodsSpecCode">
          <div>
            <span>NC编号:</span>
            <span>{{ row.ncNo }}</span>
          </div>
          <div>
            <span>{{ row.orderGoodsDisplayName }}</span>
          </div>
          <div
            v-for="(identify, index) in row.listIdentifyGoodsNo"
            :key="index"
          >
            {{ identify }}
          </div>
        </div>

        <div v-if="!!row.pdCostsOrderGoodsSpecCode && row.isGroup == 'Y'">
          <div>
            <span>子件NC编号:</span>
            <span>{{ row.ncNo }}</span>
          </div>
          <div>
            <span>子件名称:</span>
            <span>{{ row.orderGoodsName }}</span>
          </div>
          <div>
            <span>子件尺寸:</span>
            <span>{{ row.orderGoodsSpecShow }}</span>
          </div>
        </div>

        <div v-if="!!row.pdCostsOrderGoodsSpecCode && row.isGroup == 'N'">
          <div>
            <span>规格名称:</span>
            <span>{{ row.orderGoodsName }}</span>
          </div>
          <div>
            <span>规格尺寸:</span>
            <span>{{ row.orderGoodsSpecShow }}</span>
          </div>
        </div>
      </template>
      <template v-slot:orderQty="{ row }">
        <div>{{ format(row.orderQty) }}</div>
        <div v-if="row.isGroup && !row.pdCostsOrderGoodsSpecCode" class="mt-1">
          <el-tag
            style="margin: 0;"
            size="mini"
            :type="
              row.isGroup == 'Y'
                ? 'warning'
                : row.isGroup === 'N'
                ? 'primary'
                : ''
            "
          >
            {{ row.v_isGroup }}
          </el-tag>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_pdCosts') || '成本核算'"
            placement="top"
            v-if="row.pdCostsOrderGoodsSpecCode"
          >
            <i
              class="el-icon-money tool-btn"
              @click="$emit('pdCosts', row)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="
              $l('INDEX.btn_tips_pdCosts_packing_other') || '包装及其他费用'
            "
            placement="top"
            v-if="!row.pdCostsOrderGoodsSpecCode"
          >
            <i class="el-icon-box tool-btn" @click="$emit('pdCosts', row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>

    <div
      v-show="false"
      class="pdOrderGoodsImgViews"
      v-viewer="{ movable: true }"
    >
      <img
        v-for="(item, index) in viewerImgs"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="index"
      />
    </div>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import TableAutoHeight from '@/mixins/table-auto-height'
import { add, format } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      treeConfig: { reserve: true, expandAll: true, children: 'childs' },
      toolbarConfig: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
      },
      tableColumns: tableColumns(this),
      format: (number) => format(number),
      viewerImgs: [],
      viewer: null,
    }
  },
  computed: {
    height() {
      return this.tableHeight - 10 < 500 ? 500 : this.tableHeight - 10
    },
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns.map((t) => {
        const val = totalColumnValues[t.field] || ''
        return val ? val.toLocaleString() : ''
      })
      result[0] = '合计'
      return [result]
    },
  },
  methods: {
    cellClassName({ column, row }) {
      const { property } = column
      const { pdCostsOrderGoodsSpecCode } = row
      if (property !== 'col-opt' || !pdCostsOrderGoodsSpecCode) {
        return 'align-top'
      }
      return 'goods-spec-col-opt align-top'
    },
    rowStyle({ row }) {
      const { pdCostsOrderGoodsSpecCode } = row
      if (!pdCostsOrderGoodsSpecCode) return {}
      return {
        'background-color': '#fafafa',
      }
    },
    setAllTreeExpand(checked = true) {
      this.$refs.orderGoodsTable.setAllTreeExpand(checked)
    },
    clearTreeExpand() {
      this.$refs.orderGoodsTable.clearTreeExpand()
    },
    imgClick({ listImg }) {
      listImg =
        !listImg || !listImg.length ? ['/image/static/img/nopic.jpg'] : listImg
      this.viewerImgs = [...(listImg || []).map((item) => item.displayImageUrl)]
      if (this.viewer) this.viewer.destroy()
      setTimeout(() => {
        this.viewer = this.$el.querySelector('.pdOrderGoodsImgViews').$viewer
        this.viewer.update()
        let defaultIndex = (listImg || []).findIndex(
          (item) => item.isDefault == 'Y'
        )
        defaultIndex = defaultIndex < 0 ? 0 : defaultIndex
        setTimeout(() => {
          this.viewer.view(defaultIndex)
          this.viewer.show()
        }, 0)
      }, 0)
    },
  },
}
</script>
<style lang="scss">
.pd-order-goods {
  .goods-spec-col-opt {
    .vxe-tree-cell {
      padding-left: 0 !important;
    }
  }
  .vxe-body--column {
    .vxe-cell div {
      span:first-child {
        margin-right: 10px;
      }
    }
  }
}
</style>
